import React from 'react';
import PropTypes from 'prop-types';

// Components
import Markdown from '@client/components/markdown/Markdown';

// Styles
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './dialog.scss';

export const Dialog = ({
  showDialog,
  handleAbort,
  handleContinue,
  title,
  text,
  textAbort,
  textContinue,
}) => {
  return (
    showDialog && (
      <div className={styles.container}>
        <div className={styles.dialog}>
          <span className={styles.heading}>{title}</span>
          <Markdown className={styles.text} value={text} />
          <div className={styles.btnContainer}>
            <button
              className={`${styleHelper.btnFlat} ${styles.abortBtn}`}
              onClick={handleAbort}
            >
              {textAbort}
            </button>
            <button
              className={styleHelper.btnPrimaryMd}
              onClick={handleContinue}
            >
              {textContinue}
            </button>
          </div>
          <button className={styles.closeBtn} onClick={handleAbort}></button>
        </div>
      </div>
    )
  );
};

Dialog.propTypes = {
  showDialog: PropTypes.bool.isRequired,
  handleAbort: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  textAbort: PropTypes.string.isRequired,
  textContinue: PropTypes.string.isRequired,
};
